/** Canonical consultation service used by booking CTAs and deep links. */
export const CONSULTATION_SERVICE_SLUG = 'quick-consultation-natural-hair'

export const CONSULTATION_SERVICE_URL = `/services/${CONSULTATION_SERVICE_SLUG}`
